import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';

import AlertGenericModal from 'react/containers/modals/AlertGenericModal';
import ProfileMenuItem from './ProfileMenuItem';
import ChangePassword from './ChangePassword';

function ProfileMenu({ isDsgUser }) {
  const [activeItem, setActiveItem] = useState(null);
  const [confirmLogout, setConfirmLogout] = useState(false);

  const toggleMenu = (id) => {
    setActiveItem((actualActiveMenu) => (actualActiveMenu === id ? null : id));
  };

  const isActive = (id) => activeItem === id;

  const logoutConfirmation = () => {
    setConfirmLogout(!confirmLogout);
  };

  const logoutFunction = () => {
    const gmStorage = new Greenmile.Storage.StoreMapPosition();

    if (!gmStorage.isUpdate()) {
      const actions = new Greenmile.UserPreferences.Actions();
      actions.saveOrUpdateUserPreferencesAndLogout();
    } else {
      Monet.Authentication.logout();
    }
  };

  useEffect(() => {
    Greenmile.LoadAllSessionInfo.renderUserSelectOrganizations();
  }, []);

  return (
    <div id="menuContainer" data-testid="menuContainer">
      <div id="menuContent" className="menuContent" />

      {!isDsgUser && (
        <ProfileMenuItem
          id="changePassword"
          title="topMenu.UserProfile.ChangePassword"
          onClick={() => toggleMenu('changePassword')}
          isOpen={isActive('changePassword')}
        >
          <ChangePassword isParentMenuOpen={isActive('changePassword')} />
        </ProfileMenuItem>
      )}

      {isDsgUser && (
        <ProfileMenuItem
          id="dsgMyAccount"
          title="topMenu.UserProfile.MyAccount"
          onClick={() => {
            window.open('https://www.myvan.descartes.com/IdentityServiceUI/Accounts', '_blank');
          }}
        />
      )}

      <ProfileMenuItem
        id="organizationVisibility"
        title="topMenu.UserProfile.OrganizationVisibility"
        onClick={() => toggleMenu('organizationVisibility')}
        isOpen={isActive('organizationVisibility')}
      >
        <div id="GreenmileDispatcherSelectOrganizations" />
      </ProfileMenuItem>

      <ProfileMenuItem
        id="GreenmileUserProfileItemsLogout"
        title="topMenu.UserProfile.SignOut"
        onClick={() => logoutConfirmation()}
      />

      <AlertGenericModal
        open={confirmLogout}
        i18n={Monet.I18n}
        title="ModalLogout.Title"
        message="ModalLogout.Content"
        confirmClickButton={logoutFunction}
        cancelClickButton={logoutConfirmation}
        customConfirmButtonResource="ModalLogout.ConfirmButton"
      />
    </div>
  );
}

ProfileMenu.propTypes = {
  isDsgUser: PropTypes.bool.isRequired
};

export default memo(ProfileMenu);
